import { Component, Input, OnInit } from '@angular/core';
import { EndCustomerCircuit } from '../../_models/portal/end-customer-circuit.model';

type NestedEndCustomerCircuit =
  | keyof EndCustomerCircuit
  | 'circuit_no'
  | 'device_serial_no'
  | 'pppoe_username'
  | 'pppoe_password'
  | 'wifi_ssid'
  | 'wifi_password';

interface CircuitField {
  field: NestedEndCustomerCircuit;
  header: string;
  type: 'text' | 'date' | 'string' | 'number' | 'currency' | 'status';
}

@Component({
  selector: 'share-end-customer-circuit-details',
  templateUrl: './share-end-customer-circuit-details.component.html',
  styleUrls: ['./share-end-customer-circuit-details.component.scss']
})
export class ShareEndCustomerCircuitDetailsComponent implements OnInit {
  circuitDetailsFieldsToDisplay: CircuitField[] = [
    { field: 'circuit_no', header: 'Circuit Number', type: 'text' },
    { field: 'device_serial_no', header: 'Device Serial Number', type: 'text' },
    { field: 'pppoe_username', header: 'PPPoE Username', type: 'text' },
    { field: 'pppoe_password', header: 'PPPoE Password', type: 'text' },
    { field: 'wifi_ssid', header: 'WiFi SSID', type: 'text' },
    { field: 'wifi_password', header: 'WiFi Password', type: 'text' }
  ];

  @Input() circuitDetails: EndCustomerCircuit | undefined;

  constructor() {}

  ngOnInit(): void {}

  get hasCircuitData(): boolean {
    if (!this.circuitDetails) {
      return false;
    }

    return this.circuitDetailsFieldsToDisplay.some((field) => {
      const value = this.getCircuitFieldValue(this.circuitDetails, field.field);
      if (value === null || value === undefined) {
        return false;
      }

      if (typeof value === 'string') {
        return value.trim().length > 0;
      }

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      if (typeof value === 'object') {
        return Object.keys(value).length > 0;
      }

      return true;
    });
  }

  getCircuitFieldValue(
    circuit: EndCustomerCircuit | undefined,
    field: NestedEndCustomerCircuit
  ): any {
    if (!circuit) {
      return null;
    }

    const fieldParts = field.split('.');
    let value: any = circuit;
    for (const part of fieldParts) {
      if (value) {
        value = value[part];
      } else {
        return null;
      }
    }
    return value;
  }

  getDisplayValue(field: NestedEndCustomerCircuit): string {
    const value = this.getCircuitFieldValue(this.circuitDetails, field);

    if (value === null || value === undefined) {
      return '';
    }

    if (typeof value === 'string') {
      return value;
    }

    if (typeof value === 'number' || typeof value === 'boolean') {
      return value.toString();
    }

    return '';
  }
}
